export default (options) => {
  return {
    applyHtmlTags: ['li'].map(tag => tag.toLowerCase())
  }
}
